var companyStoreActions;
(function (companyStoreActions) {
    companyStoreActions["GET"] = "GET";
    companyStoreActions["POST"] = "POST";
    companyStoreActions["PUT"] = "PUT";
    companyStoreActions["GET_BORDERS"] = "GET_BORDERS";
    companyStoreActions["TOGGLE_AREAS"] = "TOGGLE_AREAS";
    companyStoreActions["GET_PRE_BOOKINGS"] = "GET_PRE_BOOKINGS";
})(companyStoreActions || (companyStoreActions = {}));
export default companyStoreActions;
